<template>
    <el-dialog :visible.sync="openDialog" :append-to-body="true" custom-class="select-goods-new-dialog" @closed="closed" width="calc(100% - 40px)" top="20px" :title="title" :close-on-click-modal="false">
        <div class="select-wrap">
            <div class="select-wrap-left">
                <div class="tree-box">
                    <el-tree
                        ref="treeRef"
                        :data="treeData"
                        :highlight-current="true"
                        :current-node-key="selectTreeId"
                        :expand-on-click-node="false"
                        node-key="id"
                        :props="defaultProps"
                        @node-click="treeNodeClick"
                    ></el-tree>
                </div>
            </div>
            <div class="select-wrap-right">
                <div class="top-search">
                    <el-input size="mini" placeholder="请输入名称、规格、型号等关键字查询" clearable v-model="quertInfo.objMap.keyword" style="width: 320px" prefix-icon="el-icon-search"></el-input>
                    <el-button size="mini" type="primary" @click="onSearch" style="margin-left:10px">搜索</el-button>
                </div>
                <div class="table-box">
                    <el-table :data="tableData" border size="mini" ref="tableRef" :height="`calc(100vh - 200px)`" :header-cell-style="headerCellStyle">
                        <el-table-column prop="code" label="物料编码" :show-overflow-tooltip="true"  width="160"></el-table-column>
                        <el-table-column prop="name" label="物料名称" :show-overflow-tooltip="true"   width="160"></el-table-column>
                        <el-table-column prop="classifyName" label="物料分类" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="sspace" label="规格" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="model" label="型号" :show-overflow-tooltip="true"></el-table-column>
                     <!--    <el-table-column prop="figueNumber" label="图号" :show-overflow-tooltip="true"></el-table-column> -->
                        <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true" width="100"></el-table-column>
                        <el-table-column label="操作" width="90" align="left" fixed="right">
                            <template slot-scope="scope">
                            <el-button type="text" size="small" :disabled="disGoodsIds[scope.row.id]" @click="selectRow(scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination-box">
                    <pagination v-show="count>0" size="mini"
                        @on-pagination="onPagination"
                        :page.sync="quertInfo.page"
						layout="total, prev, pager, next"
                        :limit.sync="quertInfo.limit"
                        :total="count"
                    >
					</pagination>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { queryByParentId } from '@/api/basic/commodityClassification.js'
import { commodityList } from '@/api/basic/commodity.js'
export default {
    data(){
        return {
            disGoodsIds:{},
            title:'选择物料',
            openDialog:false,
            treeData:[],
            selectTreeId:'',
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            count: 0,
			quertInfo: {
				page: 1, //当前页码
				limit: 10, //当前每页显示的数量
				objMap: {
                    classifyId:"",
                    keyword:'',
				}
            },
            tableData:[],
        }
    },
    created(){
    },
    methods:{
        init(goods){
            this.disGoodsIds = {};
            if(goods && goods.length>0){
                goods.forEach((go)=>{
                    this.disGoodsIds[go.commodityId] = true
                })
            }
            this.openDialog = true;
            this.getGysClass();
        },
        closed(){
            this.selectTreeId='';
            this.count=0;
            this.quertInfo.page = 1;
            this.quertInfo.objMap = {
                classifyId:"",
                keyword:'',
                // status:2
            };
            this.treeData=[];
            this.tableData=[];
        },
        // 获取商品分类
        async getGysClass(){
            let _this = this;
            const { data: res } = await queryByParentId({})
            if (res.code == 0) {
                let treeData = res.data||[];
                if(treeData[0]){
                    treeData[0]['name'] = '全部';

                }
                this.treeData = treeData;
                _this.$nextTick(()=>{
                    if(_this.treeData.length>0){
                        _this.$refs.treeRef.setCurrentKey(treeData[0].id+'');
                        _this.selectTreeId = treeData[0].id+'';
                    }
                })

            }
        },
        // 点击树
        treeNodeClick(data){
            let _this = this;
            _this.$refs.treeRef.setCurrentKey(data.id+'');
            _this.selectTreeId = data.id+'';
        },
        onSearch(){
            this.quertInfo.page = 1;
            this.getGysList()
        },
        async getGysList() {
			let _this = this;
            this.$nextTick(async ()=>{
                const { data: res } = await commodityList(_this.quertInfo)
                if (res.code == 0) {
                    _this.tableData = res.data||[];
                    _this.count = res.count;
                }
            })
        },
        onPagination: function (val) {
			this.quertInfo.page = val.page;
			this.quertInfo.limit = val.limit;
			this.getGysList();
		},
        selectRow(row){
            this.$emit('callback', {type:'add',data:row});
        },
    },
    watch:{
        'selectTreeId':function(val){
            console.log(val)
            this.quertInfo.objMap.classifyId = val;
            if(val == 1){
                this.quertInfo.objMap.classifyId = '';
            }
            this.quertInfo.objMap.keyword = '';
            this.$nextTick(()=>{
                this.onSearch();
            })
        },
    }
}
</script>
<style lang="scss">
    .select-goods-new-dialog{
        margin-bottom: 20px;
        .hide-fx{
            th{
                .el-checkbox{
                    display: none;
                }
            }
            .el-radio__label{
                display: none;
            }
        }
        .select-wrap{
            width: 100%;
            height: calc(100vh - 160px);
            display: flex;
            justify-content: space-between;
            .select-wrap-left{
                width: 260px;
                padding-right: 20px;
                border-right: 1px solid #e8e8e8;
                height: calc(100vh - 160px);
                overflow-y: auto;
            }
            .select-wrap-right{
                flex: 1;
                padding: 0 10px;
                overflow-y: auto;
                overflow-x: hidden;
                display: flex;
                flex-direction: column;
                .pagination-box{
                    width: 100%;
                    text-align: right;
                }
                .table-box{
                    margin: 10px 0;
                    min-height: 400px;
                    overflow: hidden;
                }
                .select-view{
                    flex: 1;
                    margin-top: 10px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    h3{
                        font-size: 14px;
                        line-height: 20px;
                    }
                    .gys-names{
                        flex: 1;
                        border: 1px solid #e8e8e8;
                        border-radius: 5px;
                        margin-top: 10px;
                        min-height: 100px;
                        overflow-y: auto;
                        padding: 10px;
                    }
                }
            }
        }
    }
</style>
